// extracted by mini-css-extract-plugin
export default {"spinnerBox":"Loader_spinnerBox__wXI3y","spinnerBorder":"Loader_spinnerBorder__m+nbD","spinner-border":"Loader_spinner-border__Gqbwr"};